import { render, staticRenderFns } from "./RenderRichText.vue?vue&type=template&id=439933ac&scoped=true"
import script from "./RenderRichText.vue?vue&type=script&lang=js"
export * from "./RenderRichText.vue?vue&type=script&lang=js"
import style0 from "./RenderRichText.vue?vue&type=style&index=0&id=439933ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439933ac",
  null
  
)

export default component.exports